import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormArray, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {UserType} from '../../../Shared/Enums/UserType';
import {AuthService} from '../../../Shared/Services/auth.service';
import {DtoProductListVM} from '../../../Model/price-list/DtoProductListVM';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {
  @Input() list: DtoProductListVM = {};
  @Input() items!: FormGroup[];
  @Output() valueChanged: EventEmitter<FormGroup[]> = new EventEmitter<FormGroup[]>();
  colorColumnCount: number = 2;
  nonColorColumnCount: number = 3;
  colorColumns: number[] = [];
  nonColorColumns: number[] = [];
  itemsWithColors: FormGroup[][] = [];
  itemsWithoutColors: FormGroup[][] = [];

  constructor(private auth: AuthService, private router: Router) {
  }

  ngOnInit() {
    this.colorColumns = this.GenerateColumns(this.colorColumnCount);
    this.nonColorColumns = this.GenerateColumns(this.nonColorColumnCount);
    this.itemsWithColors = this.GetItemsWithColors();
    this.itemsWithoutColors = this.GetItemsWithoutColors();
  }

  GetItemsWithColors(): FormGroup[][] {
    let items = this.items.filter(x => x.get("haveColor")?.value == true) as FormGroup[];
    let rowItems: FormGroup[][] = [];
    // Convert to double-column (pairing items)
    for (let i = 0; i < items.length; i += this.colorColumnCount) {
      rowItems.push(items.slice(i, i + this.colorColumnCount));
    }
    return rowItems;
  }

  GetItemsWithoutColors(): FormGroup[][] {
    let items = this.items.filter(x => x.get("haveColor")?.value !== true) as FormGroup[];
    let rowItems: FormGroup[][] = [];
    // Convert to double-column (pairing items)
    for (let i = 0; i < items.length; i += this.nonColorColumnCount) {
      rowItems.push(items.slice(i, i + this.nonColorColumnCount));
    }
    return rowItems;
  }

  GetColorItems(itemForm: FormGroup, colorId?: number): FormGroup | null {
    if(!itemForm) return null;
    let input: FormGroup = ((itemForm?.controls["variants"] as FormArray)?.controls as FormGroup[])
      .find(x => x.get("colorId")?.value == colorId) as FormGroup;
    input?.valueChanges.subscribe(x => {
      this.valueChanged.emit(this.items);
    });
    return input;
  }

  GetNonColorItems(itemForm: FormGroup): FormGroup | null {
    if(!itemForm) return null;
    let input: FormGroup = itemForm;
    input?.valueChanges.subscribe(x => {
      this.valueChanged.emit(this.items);
    });
    return input;
  }

  GenerateColumns(count: number) {
    return Array(count).fill(0).map((_, i) => i);
  }
}
